import { UserType } from '@avanta/shared/constants/users';
import { SUPPORTER_ID } from 'constants/chat';
import { useFetchUser } from 'hooks/useFetchUser';
import { useIsPatientOrEmployee, useIsPsychologist } from 'stores/user';

export const useSendNotificationEmail = (
  receiverId: string
): { isEnabledEmailNotification: boolean } => {
  const user = receiverId === SUPPORTER_ID ? undefined : receiverId;
  const { data: receiverUser } = useFetchUser(user);
  const isPatientOrEmployee = useIsPatientOrEmployee();
  const isPsychologist = useIsPsychologist();

  const isReceiverPsychologist = receiverUser?.type === UserType.PSYCHOLOGIST;
  const isReceiverPatientOrEmployee =
    receiverUser?.type === UserType.PATIENT || receiverUser?.type === UserType.EMPLOYEE;

  const isEnabledEmailNotification =
    (isPatientOrEmployee && isReceiverPsychologist) ||
    (isPsychologist && isReceiverPatientOrEmployee);

  return { isEnabledEmailNotification };
};
